import React from "react";

export default function Footer() {

  return <div className="container-fluid" style={{position:'fixed',bottom:0}}>
  <div className="row  bg-dark pa2">
   <h6 className="center gray">© 2019 TecRidge inc.</h6>
  </div>
  </div>
}
